import * as React from "react";

interface ModuleTitleProps {
  heading: string;
  subHeading?: string;
}

export const ModuleTitle: React.FC<ModuleTitleProps> = ({ heading, subHeading }) => {
  return (
    <>
      <h2 className="uitk-type-heading-600 all-b-margin-one">{heading}</h2>
      {subHeading && <div className="uitk-type-300">{subHeading}</div>}
    </>
  );
};

ModuleTitle.displayName = "ModuleTitle";
